import React from "react";
import {
  Alert,
  Box,
  Button,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { siteMeta } from "../../data/mockData";

const initialForm = {
  firstName: "",
  lastName: "",
  email: "",
  message: "",
};

const Contact = ({ compact = false }) => {
  const [form, setForm] = React.useState(initialForm);
  const [errors, setErrors] = React.useState({});
  const [status, setStatus] = React.useState(null);

  const validate = () => {
    const nextErrors = {};

    if (!form.firstName.trim()) nextErrors.firstName = "First name is required.";
    if (!form.lastName.trim()) nextErrors.lastName = "Last name is required.";
    if (!form.email.trim()) {
      nextErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      nextErrors.email = "Enter a valid email address.";
    }
    if (!form.message.trim()) nextErrors.message = "Message is required.";

    return nextErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const nextErrors = validate();
    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      setStatus("validation");
      return;
    }

    setStatus("ready");
  };

  const handleChange = (field) => (event) => {
    setForm((current) => ({ ...current, [field]: event.target.value }));
    setErrors((current) => ({ ...current, [field]: undefined }));
    setStatus(null);
  };

  return (
    <Box
      sx={{
        p: { xs: 2.9, md: compact ? 3.1 : 4 },
        borderRadius: "var(--radius-card)",
        bgcolor: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        boxShadow: "var(--shadow-card)",
      }}
    >
      <Typography variant={compact ? "h5" : "h4"}>
        Inquiry Form
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1.4, mb: 3 }}>
        Please use the listed contact details for formal correspondence. This
        form may be used to prepare inquiry details before submission through
        the company's official communication channels.
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="First name"
                value={form.firstName}
                onChange={handleChange("firstName")}
                error={Boolean(errors.firstName)}
                helperText={errors.firstName}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Last name"
                value={form.lastName}
                onChange={handleChange("lastName")}
                error={Boolean(errors.lastName)}
                helperText={errors.lastName}
                fullWidth
              />
            </Grid>
          </Grid>
          <TextField
            label="Email"
            type="email"
            value={form.email}
            onChange={handleChange("email")}
            error={Boolean(errors.email)}
            helperText={errors.email}
            fullWidth
          />
          <TextField
            label="How can Refwa help?"
            value={form.message}
            onChange={handleChange("message")}
            error={Boolean(errors.message)}
            helperText={errors.message}
            multiline
            minRows={compact ? 3 : 5}
            fullWidth
          />

          {status === "validation" ? (
            <Alert severity="warning">
              Please complete the required fields before preparing your inquiry.
            </Alert>
          ) : null}

          {status === "ready" ? (
            <Alert severity="info">
              Your inquiry details are ready for review. Please use {siteMeta.email} or the listed contact details for formal submission.
            </Alert>
          ) : null}

          <Button type="submit" variant="contained" size="large">
            Prepare Inquiry
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default Contact;
